module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-3 pt-5",
    class: {
      'bg-white': _vm.isEmpty
    }
  }, [(_vm.isEmpty) ? [_c('empty-page', {
    attrs: {
      "title": "沒有指派任何考試作業",
      "description": "目前沒有老師指派任何考試作業給您。"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 d-flex"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block mt-5 mb-5 w-50 mx-auto",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.push('/')
      }
    }
  }, [_vm._v("我知道了")])])] : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 offset-sm-3"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.exams.list), function(exam) {
    return _c('li', {
      key: exam.id,
      staticClass: "list-group-item d-flex justify-content-between p-0 mb-3 rounded"
    }, [_c('div', {
      staticClass: "text-left p-3 mr-auto"
    }, [_vm._v("\n              考試內容："), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(exam.name))]), _c('br'), _vm._v("\n              指派班級：" + _vm._s(exam.groupName)), _c('br'), _vm._v("\n              指派老師：" + _vm._s(exam.teacherName)), _c('br'), _vm._v("\n              建立日期：" + _vm._s(exam.createTime) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center pr-3"
    }, [(exam.isDone) ? _c('img', {
      attrs: {
        "src": require("../assets/image/icon/check_on.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/image/icon/check_off.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center rounded list-group-item-playbtn",
      staticStyle: {
        "background-color": "#5aa5f8"
      }
    }, [_c('span', {
      staticClass: "w-100 text-center",
      on: {
        "click": function($event) {
          _vm.$router.push('/exams/start/' + exam.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/image/icon/video_play.png")
      }
    })])])])
  }), 0), _vm._v(" "), _c('pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.exams.pageIndex,
      "total": _vm.exams.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v("考試作業")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c15a602a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Exams.vue
// module id = 748
// module chunks = 1